



























import { computed, defineComponent, reactive, ref, watch } from '@vue/composition-api';
import { formatSize } from '@/renderer/scripts/utils/tools/index';
export default defineComponent({
  name: 'userConfigBar',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    spaceSizeInfo: {
      type: Object,
      required: true,
    },
  },
  setup(props, context) {
    const sizeInfo = computed(() => formatSize(props.spaceSizeInfo.personalSpaceQuotaSize, true));
    const methods = {
      submit() {
        context.emit('submit');
      },
    };
    return {
      sizeInfo,
      ...methods,
    };
  },
});
